// extracted by mini-css-extract-plugin
export default {"main":"not-found-404_main__--a3g","title":"not-found-404_title__exz71","link":"not-found-404_link__mIDZL"};